module.exports = __webpack_public_path__ + "static/media/ecology.555392df.png";